import { memo } from 'react';
import { areEqual, ListChildComponentProps } from 'react-window';
import { Draggable } from 'react-beautiful-dnd';

import { DataAttribute } from '../../DataAttribute';

export const DataAttributeLibraryRow = memo(({ data, index, style }: ListChildComponentProps) => {
  const item = data[index];
  const draggableId = JSON.stringify({
    id: item.id,
    label: item.label,
    type: item.type,
    signalType: item.signalType,
    isAttribute: true,
  });

  return (
    <Draggable draggableId={draggableId} index={index} key={item.id} isDragDisabled={item.signalType === 'composite'}>
      {(provided) => (
        <>
          {/* {item.type} */}
          <DataAttribute provided={provided} item={item} style={style} isCloudShown={item.signalType === 'foreign'} />
        </>
      )}
    </Draggable>
  );
}, areEqual);

DataAttributeLibraryRow.displayName = 'DataAttributeLibraryRow';
